import React from 'react';
import { Share as ShareButtons } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

import './style.scss';

const Share = (props) => {
  const {
    title = null,
    pageTitle,
    items = [
      'facebook',
      'twitter',
      'linkedin',
      'whatsapp',
      'mail',
    ],
  } = props;

  const { t } = useTranslation();
  const url = typeof window !== 'undefined' && window.location.href || '';

  return (
    <div>
      <ShareButtons
        title={(title || t('share'))}
        items={items}
        pageTitle={title}
        url={url}
      />
    </div>
  );
};

export default Share;
